exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".grid-content[data-v-6e168229]{border-radius:4px;min-height:30px;color:#d9001b}.row-bg[data-v-6e168229]{padding:7px 0;background:#fef0f0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e168229","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/widgets/ImportFile.vue
// module id = 1785
// module chunks = 0